// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelType-Container_cls1__d7cK1","cls2":"PaymentChannelType-Container_cls2__8l5dk PaymentChannelType-Container_cls1__d7cK1"};